var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_4034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7732 7.72138C22.3043 7.18098 21.7248 6.74766 21.0738 6.45073C20.4229 6.15381 19.7157 6.00023 19.0002 6.00038H15.0112L15.3472 3.95938C15.4661 3.24064 15.3227 2.50311 14.9431 1.88132C14.5635 1.25952 13.9731 0.79489 13.2794 0.572169C12.5858 0.349448 11.8352 0.383478 11.1646 0.668053C10.494 0.952627 9.94801 1.46878 9.62624 2.12238L8.00024 5.41738V21.0004H18.3002C19.5037 20.9955 20.6654 20.5587 21.574 19.7695C22.4827 18.9804 23.0778 17.8913 23.2512 16.7004L23.9562 11.7004C24.0559 10.9911 24.0019 10.2687 23.7978 9.58214C23.5936 8.89559 23.2442 8.26099 22.7732 7.72138Z",
    fill: "#7161ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11V16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21H6V6H5C3.67441 6.00159 2.40356 6.52888 1.46622 7.46622C0.528882 8.40356 0.00158786 9.67441 0 11H0Z",
    fill: "#7161ba"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_4034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpPurple);
export default __webpack_public_path__ + "static/media/thumbUpPurple.7ae0889ead6d0f4b8f9846949693dd8a.svg";
export { ForwardRef as ReactComponent };